import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  cursor: copy;
  font-size: ${props =>
    props.fontSize ? props.fontSize : ({ theme }) => theme.FONT_SIZES.BASE};
  ${props => props.color && `color: ${props.color};`};
  & > svg {
    width: auto;
    margin: 0px 5px;
    height: ${props =>
      props.fontSize ? props.fontSize : ({ theme }) => theme.FONT_SIZES.BASE};
  }
`;

export default Wrapper;
